<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">公司列表</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">商家名稱</label>
                    <Input size="small" v-model="form.name" clearable @keyup.enter.native="handleSearch()"/>
                </FormItem>
                <!-- <FormItem>
                    <label class="input-label">手機號碼</label>
                    <Input size="small" v-model="form.phone" clearable @keyup.enter.native="handleSearch()"/>
                </FormItem> -->
                <FormItem>
                    <label class="input-label">商家標識搜索</label>
                    <Input size="small" v-model="form.mark" clearable @keyup.enter.native="handleSearch()"/>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleSearch">搜索</div>
                        <!-- <div class="pg-btn style2">導出excel</div> -->
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增公司</div>
                </div>
            </div>
            <Table size="small"
				   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">編輯資料</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">凍結賬戶</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(index)" v-if="row.deleted_at == ''">凍結商家</div>
                        <div class="pg-btn style1" @click="handleDelete(index)" v-else-if="row.deleted_at != ''" style="background: #03a9f4;">啟用商家</div> -->
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                isSubmiting: false,
				form: {
				    mark: '',
				    // phone: '',
                    name: ''
				},
                table: {
                    column: [
                        {
                            title: '主用戶編號',
                            key: 'id',
                            align: 'center',
							sortable: true,
                            minWidth: 120
                        },
						{
						    title: '商家名稱',
						    key: 'name',
						    align: 'center',
							sortable: true,
						    minWidth: 100
						},
                        {
                            title: '商家標識',
                            key: 'mark',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '是否包郵',
                            key: 'free_shipping',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '首重',
                            key: 'first_cost',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '續重',
                            key: 'renewal_cost',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '澳運國際分帳(百分比)',
                            key: 'divide_equally_enterprise',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '商家分帳(百分比)',
                            key: 'delide_equally_my',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '充值餘額',
                            key: 'balance',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '超期費時間',
                            key: 'outtime_day',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '說明備註',
                            key: 'description',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '商家創建時間',
                            key: 'created_at',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '商家更新時間',
                            key: 'updated_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '商家刪除時間',
                            key: 'deleted_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 200
                        }
                    ],
                    data: []
                }
            };
        },
        activated() {
            this.getList();
        },
        mounted() {
            this.getList();
        },
        methods: {
            formatDate(datetime)
            {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            getList() {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.samecityUserList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        name: form.name,
                        mark: form.mark
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {
                            tempArr.push({
                                balance: resData[i].balance == null ? '---' : resData[i].balance,
                                renewal_cost: resData[i].renewal_cost,
                                name: resData[i].name,
                                mark: resData[i].mark,
                                id: resData[i].id,
                                first_cost: resData[i].first_cost,
                                free_shipping: resData[i].free_shipping == 1 ? '有' : '沒有',
                                divide_equally_enterprise: resData[i].divide_equally_enterprise == null ? '---' : resData[i].divide_equally_enterprise + '%',
                                delide_equally_my: resData[i].delide_equally_my  == null ? '---' : resData[i].delide_equally_my + '%',
								description: resData[i].description,
                                outtime_day: resData[i].outtime_day,
                                created_at: this.formatDate(resData[i].created_at),
                                updated_at: this.formatDate(resData[i].updated_at),
                                deleted_at: resData[i].deleted_at == null ? '---' : this.formatDate(resData[i].deleted_at) 
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
            handleToAdd() {
                this.$router.push({path: '/samecityMasterlistAdd'});
            },
            handleEdit(index) {
                let tableData = this.table.data;
                this.$router.push({path: '/samecityMasterlistEdit?id=' + tableData[index].id})
            },
			handleDelete(index) {
			    this.$Modal.confirm({
			        title: '提示',
			        content: '確定凍結賬戶嗎？',
			        cancelText: '取消',
			        okText: '確定',
			        onOk: () => {
			            let tableData = this.table.data;
			            this.isSubmiting = true;
			            this.$Rq.requestAuth({
			                url: this.$Api.samecityUserListSoftDelete,
			                method: 'post',
                            data:{
                                id: tableData[index].id
                            }
			            }).then((res) => {
			                this.isSubmiting = false;
			                if (res.code == 0) {
			                    this.$Utils.showSuccess(res.msg);
			                    this.pageIndex = 1;
			                    this.getList();
			                } else {
			                    this.$Utils.showTipInfo(res.msg);
			                }
			            }).catch((err) => {
			                this.isSubmiting = false;
			            });
			        }
			    });
			},
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount) {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0) {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'samecityMasterlist.scss';
</style>